export const DEFAULT_ORGANIZATION_ID = "team-readyfit";

export const getOrganizationId = (organizationId?: string) => {
  return organizationId || DEFAULT_ORGANIZATION_ID;
};
